/**
 * Main menu Paperwork (Admin desk) — Line-2 peers.
 * Overview · Working · queue filters live on Overview via ?queue=
 */

export const PAPERWORK_QUEUES = [
  { id: 'issue_waiting', label: 'Council processing' },
  { id: 'draft_paper', label: 'Draft paper' },
  { id: 'defect_stuck', label: 'Defect stuck' },
  { id: 'file_ready', label: 'Ready to submit' },
];

export function getPaperworkPeerNav(pathname) {
  const peers = [
    { id: 'overview', label: 'Overview', to: '/paperwork' },
    { id: 'working', label: 'Working', to: '/paperwork/working' },
  ];
  const activeId = detectPaperworkPeer(pathname);
  return peers.map((p) => ({ label: p.label, to: p.to, active: p.id === activeId }));
}

function detectPaperworkPeer(pathname) {
  const p = pathname || '';
  if (p.startsWith('/paperwork/working')) return 'working';
  if (p.startsWith('/paperwork/tasks')) return 'working';
  if (p.startsWith('/paperwork')) return 'overview';
  return 'overview';
}

export function resolvePaperworkNav({ pathname }) {
  const p = pathname || '';
  if (p.startsWith('/paperwork/tasks/')) {
    return {
      trail: [
        { label: 'Paperwork', to: '/paperwork' },
        { label: 'Working', to: '/paperwork/working' },
      ],
      subPages: getPaperworkPeerNav(p),
    };
  }
  if (p.startsWith('/paperwork/working')) {
    return {
      trail: [{ label: 'Paperwork', to: '/paperwork' }],
      subPages: getPaperworkPeerNav(p),
    };
  }
  return {
    trail: [],
    subPages: getPaperworkPeerNav(p),
  };
}

export function queueBadgeClass(queueType) {
  const q = queueType === 'lodge_waiting' ? 'file_ready' : queueType;
  switch (q) {
    case 'issue_waiting':
      return 'bg-amber-100 text-amber-900 border-amber-300';
    case 'draft_paper':
      return 'bg-orange-100 text-orange-900 border-orange-300';
    case 'defect_stuck':
      return 'bg-red-100 text-red-900 border-red-300';
    case 'file_ready':
      return 'bg-emerald-100 text-emerald-900 border-emerald-300';
    case 'chase':
      return 'bg-violet-100 text-violet-900 border-violet-300';
    default:
      return 'bg-slate-100 text-slate-800 border-slate-300';
  }
}
